module.exports = __webpack_public_path__ + "static/img/firebase_dark.4f3da63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/firebase_dark.png
// module id = kUjk
// module chunks = 1